<script>
  export default {
    name: 'error-message',
    data() {
    return {
      errors1: null,
        visible1:this.visible,
      };
  },
      props: {
          visible: {
              required: true
          },
          errors: {
              required: true
          },
          message: {
              required: true
          },
      },
    methods:{
        show() {
            this.showModal = true
        },
        hide(){
            this.$emit('close', this.visible);
            // this.visible = false
        }
    }
};
</script>

<template>
    <div v-if="visible">
        <div id="modal">
            <strong>{{errors}}</strong><br>
            {{message}}
            <span class="closebtn"><button @click="hide">x</button></span>
        </div>
    </div>

</template>
<style scoped>
#modal{
    height: auto;
    width: 30%;
    position: fixed;
    z-index: 1;
    top:100px;
    right:50px;
    padding: 20px;
    background-color: #f44336;
    color: white;
    border-radius:5px;
}
.closebtn {
    margin-left: 15px;
    color: white;
    font-weight: bold;
    float: right;
    font-size: 22px;
    line-height: 20px;
    cursor: pointer;
    transition: 0.3s;
}

.closebtn:hover {
    color: black;
}
</style>
